module.exports = __webpack_public_path__ + "resources/img/img_main_bnr_nhncloud_book.b7ae467f78593e2cbcc1941dcf5ee5c5.png";